module.exports = __webpack_public_path__ + "img/moldova.946ff59.webp";